const FileUtilities = {
  isValid: (file) => {
    return FileUtilities.isTypeSupported(file) &&
      FileUtilities.isSizeSupported(file);
  },
  isTypeSupported: (file) => {
    return file.type.match(/image|pdf/);
  },
  isSizeSupported: (file) => {
    const MAX_ATTACHMENT_SIZE_IN_BYTES = 25000000;
    return file.size <= MAX_ATTACHMENT_SIZE_IN_BYTES
  },
  lessThan1KB: (file) => {
    const MIN_ATTACHMENT_SIZE_IN_BYTES = 1024;
    return file.size < MIN_ATTACHMENT_SIZE_IN_BYTES;
  }
};

export default FileUtilities;



// WEBPACK FOOTER //
// ./src/utils/FileUtilities.js